import { Link } from 'react-router-dom'
import { Typography } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../hooks/toolkit'
import Container from '../components/Container'
import PlanCard from '../components/PlanCard'

const About = () => {
  const { t } = useTranslation()
  usePageTitle('About | Agami')

  return (
    <Container direction="col" className="text-white" bgColorClass="bg-primary">
      <Typography variant="h1">{t('about.title')}</Typography>

      <div className="w-full mt-8 text-left">
        {/* par 1 */}
        <Typography variant="h2">{t('about.mezzoforte.title')}</Typography>
        <Typography className="mt-2 mb-4">{t('about.mezzoforte.description')}</Typography>
        <Typography className="mt-2 mb-4">
          <strong className="font-black">agami</strong> {t('about.mezzoforte.agamiDescription')}
        </Typography>

        <hr className="w-full md:w-1/2 my-6 opacity-50" />

        {/* par 2 */}
        <Typography variant="h2">{t('about.overview.title')}</Typography>
        <Typography className="mt-2 mb-4">{t('about.overview.creatorsDescription')}</Typography>
        <Typography className="mt-2 mb-4">
          <strong className="font-black">Agami global</strong> {t('about.overview.globalDescription')}
        </Typography>
        <Typography className="mt-2 mb-4">
          <strong className="font-black">Pro</strong> {t('about.overview.proDescription')}
        </Typography>

        <hr className="w-full md:w-1/2 my-6 opacity-50" />

        {/* par 3 */}
        <Typography variant="h2">{t('about.plans.title')}</Typography>

        <div className="my-4 grid grid-cols-1 md:grid-cols-3 gap-4">
          <PlanCard
            planName={t('about.plans.free.name')}
            price={0}
            features={[
              t('about.plans.free.feature1'),
              t('about.plans.free.feature2'),
              t('about.plans.free.feature3'),
              t('about.plans.free.feature4'),
            ]}
          />

          <PlanCard
            planName={t('about.plans.creator.name')}
            price={29}
            features={[
              t('about.plans.creator.feature1'),
              t('about.plans.creator.feature2'),
              t('about.plans.creator.feature3'),
              t('about.plans.creator.feature4'),
              t('about.plans.creator.feature5'),
            ]}
          />

          <PlanCard
            planName={t('about.plans.venue.name')}
            price={250}
            features={[
              t('about.plans.venue.feature1'),
              t('about.plans.venue.feature2'),
              t('about.plans.venue.feature3'),
              t('about.plans.venue.feature4'),
              t('about.plans.venue.feature5'),
            ]}
          />
        </div>
      </div>
      <Link
        to="mailto:agami@mezzoforte.design"
        className="text-accent-500 text-sm font-bold border border-accent rounded-lg px-9 py-3"
      >
        {t('about.contactUs')}
      </Link>
    </Container>
  )
}

export default About
